import { render, staticRenderFns } from "./MinigenreTitles.vue?vue&type=template&id=2bb2e629&scoped=true&"
import script from "./MinigenreTitles.vue?vue&type=script&lang=js&"
export * from "./MinigenreTitles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb2e629",
  null
  
)

export default component.exports